export const ADD_TO_CART = 'ADD_TO_CART';
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
export const CHECKOUT_INIT = 'CHECKOUT_INIT';

export const MODULE_INIT = 'MODULE_INIT';
export const MODULE_INIT_SUCCESS = 'MODULE_INIT_SUCCESS';
export const MODULE_INIT_FAILURE = 'MODULE_INIT_FAILURE';
export const SET_INITIALIZED = 'SET_INITIALIZED';

export const MODULE_SELECT_PAYMENT_METHOD = 'MODULE_SELECT_PAYMENT_METHOD';
export const MODULE_UPDATE_FORM_FIELD = 'MODULE_UPDATE_FORM_FIELD';
export const MODULE_SELECT_INSTALLMENT = 'MODULE_SELECT_INSTALLMENT';
export const MODULE_SELECT_PARTIAL = 'MODULE_SELECT_PARTIAL';

export const PRODUCT_LIST = 'PRODUCT_LIST';
export const PRODUCT_INFO = 'PRODUCT_INFO';
export const PRODUCT_INFO_SUCCESS = 'PRODUCT_INFO_SUCCESS';
export const PRODUCT_INFO_FAILURE = 'PRODUCT_INFO_FAILURE';

export const CART_REPLACE = 'CART_REPLACE';
export const SET_SHIPPING = 'SET_SHIPPING';
export const SET_SHIPPING_LIST = 'SET_SHIPPING_LIST';

export const PRODUCT_ADD_ACTIVE_PRODUCT_TO_CART = 'PRODUCT_ADD_ACTIVE_PRODUCT_TO_CART';
export const PRODUCT_SET_ACTIVE_PRODUCT_QUANTITY = 'PRODUCT_SET_ACTIVE_PRODUCT_QUANTITY';
export const PRODUCT_SET_ACTIVE_PRODUCT_PRICE = 'PRODUCT_SET_ACTIVE_PRODUCT_PRICE';
export const PRODUCT_SET_ACTIVE_PRODUCT_PRICE_DETAILS = 'PRODUCT_SET_ACTIVE_PRODUCT_PRICE_DETAILS';

export const PRODUCT_MODIFIER_ADD = 'PRODUCT_MODIFIER_ADD';
export const PRODUCT_MODIFIER_REMOVE = 'PRODUCT_MODIFIER_REMOVE';

export const VISITOR_ID_SET = 'VISITOR_ID_SET';

export const SET_AFFILIATE = 'SET_AFFILIATE';

export const SET_IFRAME_ID = 'SET_IFRAME_ID';

export const VENDOR_ID_SET = 'VENDOR_ID_SET';

export const FIELDS_SET_ERROR = 'FIELDS_SET_ERROR';

export const SET_ORDER_GATEWAY = 'SET_ORDER_GATEWAY';

export const SET_ACCOUNT_STATE = 'SET_ACCOUNT_STATE';

export const CATEGORY_REPLACE_CATEGORIES = 'CATEGORY_REPLACE_CATEGORIES';
export const CATEGORY_SET_SELECTED_CATEGORY = 'CATEGORY_SET_SELECTED_CATEGORY';

export const SORT_ORDER_SET_ORDER = 'SORT_ORDER_SET_ORDER';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js